import "./contact.css";
import { toast } from 'react-toastify'
import LocationOnIcon from "@mui/icons-material/LocationOn";
import EmailTwoToneIcon from "@mui/icons-material/EmailTwoTone";
import LocalPhoneRoundedIcon from "@mui/icons-material/LocalPhoneRounded";
import ContactForm from "../../components/ContactForm/ContactForm";
export default function Contact() {
  return (
    <section className="contactPage">
      <div className="heading">
        <small>Get in touch...</small>
        <h1> Contact Us</h1>
      </div>
      <div className="messageUsSection">
        <div className="textContent">
          <h3>Message Us</h3>
          <p>
            If you have any questions or inquiries, feel free to reach out to us.
            We would love to hear from you and assist in any way we can.
          </p>
          <p className="location">
            <p>
              <span>
                <LocationOnIcon />
              </span>
              No.31, selam main road, Kallakurichi
            </p>
            <p>
              {" "}
              <span>
                <EmailTwoToneIcon />
              </span>{" "}
              @gmail.com
            </p>
            <p>
              <span>
                <LocalPhoneRoundedIcon />
              </span>
              +91 9500422264 , 225764,222264
            </p>
        </p>
        </div>

        <div className="contactForm">
          <ContactForm />
        </div>

      </div>

     {/* <iframe
        src="https://www.google.com/search?q=No.31%2C+Salem+main+road%2C+Kallakurichi%2C+Tamil+Nadu+606202%2C+India.&rlz=1C1RXQR_enIN1131IN1131&oq=No.31%2C+Salem+main+road%2C+Kallakurichi%2C+Tamil+Nadu+606202%2C+India.&gs_lcrp=EgZjaHJvbWUyBggAEEUYOTIGCAEQRRg80gEIMzgwN2owajeoAgiwAgE&sourceid=chrome&ie=UTF-8"
        width="100%"
        height="450"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe>*/}
    </section>
  );
} 
